import React from 'react';
import './LoaderTrelloCard.scss';
const LoaderTrelloCard = () => {
  return (
    <div className="loaderTrelloCard">
      <div className="headerCard">
        <div className="headerCardRow">
          <div className="numberOrder smoothAnimationLoader" />
          <div className="orderStatusDate smoothAnimationLoader" />
        </div>
        <div className="headerCardRow">
          <div className="infoCountry smoothAnimationLoader" />
          <div className="actionModalComments smoothAnimationLoader" />
        </div>
      </div>
      <div className="bodyCard">
        <div className="bodyCardRow">
          <div className="productName smoothAnimationLoader" />
          <div className="productQuantity smoothAnimationLoader" />
        </div>
        <div className="bodyCardRow">
          <div className="productName smoothAnimationLoader" />
          <div className="productQuantity smoothAnimationLoader" />
        </div>
      </div>
    </div>
  );
};

export default LoaderTrelloCard;
